const Picture = (props) => {
  if (!props.desktopImage && !props.mobileImage) return
  // if either image is provided we still proceed, using what we have.

  // Breakpoint (px) at which we switch from the mobile image to the desktop image.
  // Defaults to 768 (md) to preserve existing behaviour; callers whose layout
  // switches at a different breakpoint (e.g. the Article Header stacks until lg)
  // pass their own so the image source matches the layout being shown.
  const breakpoint = props.breakpoint || 768

  // use the mobile as the default image if it's present, otherwise use desktopImage as the default.
  // we know that if mobileImage does not exist desktopImage must, because of the previous check
  const baseImage = props.mobileImage ? props.mobileImage : props.desktopImage
  return (
    <picture>
      {props.desktopImage && (
        <source
          srcSet={props.desktopImage.src}
          media={`screen and (min-width: ${breakpoint}px)`}
          alt={props.desktopImage.altText ? props.desktopImage.altText : ''}
        />
      )}
      {props.mobileImage && (
        <source
          srcSet={props.mobileImage.src}
          media={`screen and (max-width: ${breakpoint - 1}px)`}
          alt={props.mobileImage.altText ? props.mobileImage.altText : ''}
        />
      )}
      <img
        loading="lazy"
        className={props.className}
        src={baseImage.src}
        alt={baseImage.altText ? baseImage.altText : ''}
      />
    </picture>
  )
}

export default Picture
